import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/cbs";

export const fragments = {
	Inventory: `
		fragment Inventory on Inventory {
			id
			name
			street
			description
		}
	`,
};

const ADD_INVENTORY = `
	create_inventory (
		name: $name,
		street: $street,
		description: $description,
	) {
    ...Inventory
	}
`;

const UPDATE_INVENTORY = `
	update_inventory (
		id: $id,
		name: $name,
		street: $street,
		description: $description,
	) {
    ...Inventory
	}
`;

const DELETE_INVENTORY = `
	delete_inventory (id: $id) {
		...Inventory
	}
`;

export default {
	init() {},

	addInventory(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation InventoriesManagementCreateInventory (
					$name: String!,
					$street: String,
					$description: String
					) {
						${ADD_INVENTORY}
					}
					${fragments.Inventory}
				`,
				variables: {
					name: payload.name,
					street: payload.street,
					description: payload.description
				}
			})
			.then(response => response.data.create_inventory);
	},

	updateInventory(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation InventoriesManagementUpdateInventory (
					$id: Int!,
					$name: String!,
					$street: String,
					$description: String
					) {
						${UPDATE_INVENTORY}
					}
					${fragments.Inventory}
				`,
				variables: {
					id: payload.id,
					name: payload.name,
					street: payload.street,
					description: payload.description
				}
			})
			.then(response => response.data.update_inventory);
	},

	deleteInventory(inventoryId) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation InventoriesManagementDeleteInventory ($id: Int!) {
				${DELETE_INVENTORY}
			}
			${fragments.Inventory}
		`,
				variables: {
					id: inventoryId
				}
			})
			.then(response => response.delete_inventory);
	}
};
